'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isWhiteLabel = exports.getWhiteLabelSellerId = exports.getWhiteLabelLogo = exports.getHostName = undefined;
exports.default = reducer;

var _reselect = require('reselect');

// reducer
var DEFAULT_STATE = {
    hostname: '',
    isWhiteLabel: false,
    logo: '',
    sellerId: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.whiteLabel;
};

var getHostName = exports.getHostName = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state ? state.hostname : '';
});

var getWhiteLabelLogo = exports.getWhiteLabelLogo = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.logo;
});

var getWhiteLabelSellerId = exports.getWhiteLabelSellerId = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.sellerId;
});

var isWhiteLabel = exports.isWhiteLabel = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.isWhiteLabel;
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/whiteLabel.js
// module id = cYj3
// module chunks = 46